import { extendTheme } from '@chakra-ui/react';
import { Colors } from 'theme/colors';
import { padding } from 'theme/padding';

const components = {
  Text: {
    variants: {
      label: {
        fontSize: '10px',
        fontWeight: '600',
        letterSpacing: '0.065em',
        textTransform: 'uppercase',
      },
    },
  },
};

const theme = extendTheme({
  colors: {
    brand: Colors,
  },
  fonts: { body: 'inter', heading: 'inter' },
  components,
  space: padding,
});

export default theme;
